import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./containers/Login";
import Terms from "./containers/Login/Terms";
import Register from "./containers/Register";
import ForgotPassword from "./containers/ForgotPassword";
import WeatherDisplay from "./containers/WeatherDisplay";
import WeatherDisplayMobile from "./containers/WeatherDisplayMobile";
import MyAccount from "./containers/MyAccount";
import Help from "./containers/Help";
import Error from "./containers/Error";
import { useDeviceVariant } from "./deviceVariant";

const hasToken = () => {
  return sessionStorage.getItem("selfData") !== null;
};

const AppRoutes = ({ detectValidToken }) => {
  //  Decide which Weather Display to use (Desktop or Mobile)
  const variant = useDeviceVariant();
  const WeatherDisplayBody = variant === "mobile" ? WeatherDisplayMobile : WeatherDisplay;
  return (
    <Routes>
      {/*  Login Route with Redirect if Token Exists */}
      <Route
        path="/"
        element={hasToken() ? <Navigate to="/weather-display" /> : <Login />}
      />
      
      {/*  Terms and Registration */}
      <Route path="/terms" element={<Terms />} />
      <Route path="/register" element={hasToken() ? <Navigate to="/weather-display" /> : <Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/*  Protected Routes (Require Token) */}
      {hasToken() ? (
        <>
          <Route path="/weather-display" element={<WeatherDisplayBody detectValidToken={detectValidToken}/>} />
          <Route path="/account" element={<MyAccount />} />
          <Route path="/account/info" element={<MyAccount />} />
          <Route path="/account/group" element={<MyAccount />} />
          <Route path="/account/devices" element={<MyAccount />} />
          <Route path="/account/notifications" element={<MyAccount />} />
          <Route path="/account/settings" element={<MyAccount />} />
          <Route path="/help" element={<Help />} />
        </>
      ) : (
        <>
          {/*  If user isn't logged in, Redirect them to Login */}
          <Route path="/weather-display" element={<Navigate to="/" />} />
          <Route path="/account" element={<Navigate to="/" />} />
          <Route path="/account/info" element={<Navigate to="/" />} />
          <Route path="/account/group" element={<Navigate to="/" />} />
          <Route path="/account/devices" element={<Navigate to="/" />} />
          <Route path="/account/notifications" element={<Navigate to="/" />} />
          <Route path="/account/settings" element={<Navigate to="/" />} />
          <Route path="/help" element={<Navigate to="/" />} />
        </>
      )}

      {/*  Error Page (Catch-All Route) */}
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

export default AppRoutes;
